import { v4 as uuid } from 'uuid';
import { BACKTRACKING_NEXT_QUESTION, CLEAR_FOCUS_CURRENT_SESSION_ITEM, LOAD_RESUME_DATA, PREVIEW_RESPONSE, PREVIOUS_QUESTION, QUIZ_SUBMISSION_EVENT, UPDATE_QUIZ_SUBMIT_FLAG, RESPONSE, SESSION_STARTED_OR_RESUMED_EVENT, SET_CURRENT_SESSION_ITEM_POSITION, SET_FOCUS_TITLE_AND_INSTRUCTIONS, UPDATE_IS_TAKING, UPDATE_QUIZ_SESSION_STATUS_ON_PAGE_LOAD, UPDATE_TIMER_MINIMIZED, UPDATE_TIMER_INFO, SET_WS_TOKEN, PAGE_BLURRED_EVENT, PAGE_FOCUSED_EVENT } from '@instructure/quiz-common';
export var setCurrentSessionItemPosition = function setCurrentSessionItemPosition(position) {
  return {
    type: SET_CURRENT_SESSION_ITEM_POSITION,
    payload: {
      position: position
    }
  };
};
export var clearFocusCurrentSessionItem = function clearFocusCurrentSessionItem() {
  return {
    type: CLEAR_FOCUS_CURRENT_SESSION_ITEM,
    payload: {}
  };
};
export var setFocusTitleAndInstructions = function setFocusTitleAndInstructions(status) {
  return {
    type: SET_FOCUS_TITLE_AND_INSTRUCTIONS,
    payload: {
      status: status
    }
  };
};
export var previousQuestion = function previousQuestion() {
  return {
    type: PREVIOUS_QUESTION,
    payload: {}
  };
};
export var backtrackingNextQuestion = function backtrackingNextQuestion() {
  return {
    type: BACKTRACKING_NEXT_QUESTION,
    payload: {}
  };
};
export var updateTimerMinimized = function updateTimerMinimized(bool) {
  return {
    type: UPDATE_TIMER_MINIMIZED,
    payload: {
      timerMinimized: bool
    }
  };
};
export var updateIsTaking = function updateIsTaking(bool) {
  return {
    type: UPDATE_IS_TAKING,
    payload: {
      isTaking: bool
    }
  };
};
export var updateQuizSessionStatusOnPageLoad = function updateQuizSessionStatusOnPageLoad(status) {
  return {
    type: UPDATE_QUIZ_SESSION_STATUS_ON_PAGE_LOAD,
    payload: {
      quizSessionStatusOnPageLoad: status
    }
  };
};
export var updateTimerInfo = function updateTimerInfo(timerData) {
  return {
    type: UPDATE_TIMER_INFO,
    payload: {
      timeLeftInSeconds: timerData.timeLeftInSeconds,
      timerRunning: timerData.timerRunning || false,
      timeRecording: timerData.timeRecording || false
    }
  };
};
export var previewResponse = function previewResponse(sessionItem, value, properties) {
  var invalid = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return {
    type: PREVIEW_RESPONSE,
    payload: {
      position: sessionItem.position,
      itemId: sessionItem.getItem().id,
      userResponse: {
        value: value,
        properties: properties
      },
      invalid: invalid
    }
  };
};
export var editResponse = function editResponse(sessionItem, value, properties) {
  var invalid = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return {
    type: RESPONSE,
    payload: {
      position: sessionItem.position,
      itemId: sessionItem.getItem().id,
      userResponse: {
        value: value,
        properties: properties
      },
      invalid: invalid
    }
  };
};
export var loadResumeData = function loadResumeData(resumeData) {
  return {
    type: LOAD_RESUME_DATA,
    payload: resumeData
  };
};
export var sessionStartOrResumeEvent = function sessionStartOrResumeEvent(userAgent, ipAddress) {
  return {
    type: SESSION_STARTED_OR_RESUMED_EVENT,
    payload: {
      userAgent: userAgent,
      browserSessionId: uuid(),
      ipAddress: ipAddress
    }
  };
};

// This is not consumed by its reducer
// Instead it is processed by the eventLoggerMiddleware
export var reportPageBlurredEvent = function reportPageBlurredEvent() {
  return {
    type: PAGE_BLURRED_EVENT,
    payload: {}
  };
};

// This is not consumed by its reducer
// Instead it is processed by the eventLoggerMiddleware
export var reportPageFocusedEvent = function reportPageFocusedEvent() {
  return {
    type: PAGE_FOCUSED_EVENT,
    payload: {}
  };
};
export var submitQuizSessionEvent = function submitQuizSessionEvent() {
  return {
    type: QUIZ_SUBMISSION_EVENT,
    payload: {}
  };
};
export var setWSToken = function setWSToken(wsToken) {
  return {
    type: SET_WS_TOKEN,
    payload: {
      wsToken: wsToken
    }
  };
};
export var updateQuizSubmitFlag = function updateQuizSubmitFlag(value) {
  return {
    type: UPDATE_QUIZ_SUBMIT_FLAG,
    payload: {
      value: value
    }
  };
};